import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { Box } from "@mui/material";
import React from "react";
import { useTeamConfig } from "../TeamConfigProvider";
import { useLogout } from "../../hooks/useLogout";
import { throttleTime } from "src/utils/utils";

export const useBallparkJoinGroupNoPassErrorModal = createState({
  isOpen: false,
});

export function BallparkJoinGroupNoPassErrorModal() {
  const router = useRouterExt();
  const modalState = useBallparkJoinGroupNoPassErrorModal();
  const { handleLogout } = useLogout();
  const { TEAM_SCHEMA } = useTeamConfig();
  const groupLink = String(router?.query?.groupLink);
  const inviteeUserId = Number(router?.query?.inviteeUserId);
  const inviteLink = `/${TEAM_SCHEMA}/group_invite?groupLink=${groupLink}&inviteeUserId=${inviteeUserId}`;
  const [isLoading, setIsLoaidng] = React.useState(false);

  const onClose = async () => {
    setIsLoaidng(true);
    await handleLogout(encodeURIComponent(inviteLink) as any, {
      ignoreTeamConfigRoute: true,
    });
    await throttleTime(200, () => {
      modalState.reset();
      setIsLoaidng(false);
    });
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Finish Purchase"
      description={
        <Box py={1}>
          To join a group, you must first purchase a pass. Please purchase a
          pass by downloading the Ballpark App on your native App Store. After
          you finish purchasing a pass, utilize the same link to join a group.
        </Box>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          isLoading: isLoading,
          isDisabled: isLoading,
          label: "Close",
          onClick: async () => {
            onClose();
          },
        },
        secondaryButton: {
          isHidden: true,
          label: "Cancel",
          onClick: () => onClose(),
        },
      }}
    />
  );
}
